export { default } from "./ClinicalHistoryThumbnail";
